module.exports = __webpack_public_path__ + "static/6-649808bfeb1ba582f8bb6c53a41805e8.jpg";